import axios from "axios";
import eventAnalytics from '../../analytikaV2'

const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/client/otp`;

export async function verifyOtp({
  identifier,
  code,
  guard,
  clientId,
  deviceId,
}) {
  let config = {
    headers: {
      "x-careem-device-id": deviceId,
    },
  };
  const sessionUuid = eventAnalytics.getSessionUuid();
  if (sessionUuid) {
    config.headers["X-Careem-Session-Id"] = sessionUuid;
  }
  return axios.post(
    `${endpoint}/verification`,
    {
      identifier,
      code,
      guard,
      client_id: clientId,
    },
    config
  );
}

export async function sendOtp({ identifier, type, guard, clientId, deviceId, shieldParams }) {
  let config = {
    headers: {
      "x-careem-device-id": deviceId,
    },
  };
  const sessionUuid = eventAnalytics.getSessionUuid();
  if (sessionUuid) {
    config.headers["X-Careem-Session-Id"] = sessionUuid;
  }
  return axios.post(
    endpoint,
    {
      identifier,
      type,
      guard,
      shieldParams,
      client_id: clientId,
      multiTimeUse: false,
    },
    config
  );
}
